import { styled } from "@mui/material";

export const StyledAbout = {
  Top: styled("div")({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "clamp(30px, 5vw, 64px)",
    alignItems: "center",
    "@media (max-width: 960px)": { gridTemplateColumns: "1fr" },
  }),

  Intro: styled("div")({ maxWidth: 520 }),

  Cards: styled("div")({ display: "grid", gap: 20 }),

  Mission: styled("div", {
    shouldForwardProp: (prop) => prop !== "alt",
  })(({ theme, alt }) => ({
    position: "relative",
    padding: "30px 30px 30px 34px",
    borderRadius: theme.custom.radius.lg,
    background: "#fff",
    border: `1px solid ${theme.custom.colors.border}`,
    boxShadow: theme.custom.shadow.sm,
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 0,
      bottom: 0,
      width: 5,
      background: theme.custom.gradient.brand,
    },
    "& .mi-icon": {
      width: 46,
      height: 46,
      display: "grid",
      placeItems: "center",
      borderRadius: 13,
      color: alt ? theme.custom.colors.cyan400 : theme.custom.colors.indigo600,
      background: theme.custom.gradient.brandSoft,
      marginBottom: 16,
      "& svg": { fontSize: "1.4rem" },
    },
    "& h3": {
      fontFamily: theme.custom.fonts.display,
      fontWeight: 700,
      fontSize: "1.25rem",
    },
    "& p": { marginTop: 10, color: theme.custom.colors.textSoft },
  })),

  ValuesHead: styled("div")(({ theme }) => ({
    marginTop: "clamp(56px, 8vw, 90px)",
    textAlign: "center",
    "& h3": {
      fontFamily: theme.custom.fonts.display,
      fontWeight: 700,
      fontSize: "clamp(1.7rem, 3.5vw, 2.4rem)",
    },
    "& p": { marginTop: 12, color: theme.custom.colors.textSoft },
  })),

  Values: styled("div")({
    marginTop: 40,
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
    gap: 18,
    "@media (max-width: 960px)": { gridTemplateColumns: "repeat(2, 1fr)" },
    "@media (max-width: 520px)": { gridTemplateColumns: "1fr" },
  }),

  ValueCard: styled("div")(({ theme }) => ({
    background: theme.palette.background.soft,
    border: `1px solid ${theme.custom.colors.border}`,
    borderRadius: theme.custom.radius.md,
    padding: "26px 22px",
    transition: "transform 0.3s ease, box-shadow 0.3s ease, background 0.3s ease",
    "&:hover": {
      transform: "translateY(-6px)",
      background: "#fff",
      boxShadow: theme.custom.shadow.md,
    },
    "& .value-icon": {
      width: 48,
      height: 48,
      display: "grid",
      placeItems: "center",
      borderRadius: 13,
      color: "#fff",
      background: theme.custom.gradient.brand,
      marginBottom: 16,
      "& svg": { fontSize: "1.4rem" },
    },
    "& h4": {
      fontFamily: theme.custom.fonts.display,
      fontWeight: 700,
      fontSize: "1.05rem",
      lineHeight: 1.25,
    },
    "& p": { marginTop: 10, fontSize: "0.9rem", color: theme.custom.colors.textSoft },
  })),

  Certs: styled("div")({
    marginTop: 44,
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 20,
    "@media (max-width: 960px)": { gridTemplateColumns: "1fr" },
  }),

  CertCard: styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: 18,
    padding: "24px 28px",
    borderRadius: theme.custom.radius.lg,
    background:
      "linear-gradient(135deg, rgba(23,79,155,0.06), rgba(75,163,224,0.06))",
    border: "1px solid rgba(23, 79, 155, 0.18)",
    "& .badge": {
      flexShrink: 0,
      width: 48,
      height: 48,
      display: "grid",
      placeItems: "center",
      borderRadius: "50%",
      fontSize: "1.4rem",
      fontWeight: 700,
      color: "#fff",
      background: theme.custom.gradient.brand,
      boxShadow: "0 10px 22px -10px rgba(23, 79, 155, 0.7)",
    },
    "& h4": {
      fontFamily: theme.custom.fonts.display,
      fontWeight: 700,
      fontSize: "1.15rem",
    },
    "& p": { marginTop: 4, color: theme.custom.colors.textSoft, fontSize: "0.94rem" },
  })),
};
